import { observable, action, runInAction, toJS } from 'mobx';
import * as SignAPI from '../../../api/pc/signup';
import { MDialog } from '@weapp/ui';
import { signupParamsType } from './type';
import { getLabel } from '@weapp/utils';
import { setTokenStorage } from '../../../utils';

const { toast } = MDialog;
export class mLoginStore {
  @observable countryCodeList: any[] = [];
  @observable ipLimit: boolean = false;
  @action
  countryCodeInit = (callback?: any) => {
    runInAction(() => {

    });
  };
  @action
  getSignup = (obj: signupParamsType, callback: any) => {
    SignAPI.sign(obj).then((result: any) => {
      if (result?.data?.errorMsg) {
        toast({
          content: getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg)
        })
        if (result.data.errorMsg.code === 10219) {
          runInAction(() => {
            this.ipLimit = true;
          });
        }
      } else {
        if (result?.code !== 200) {
          return;
        }
        if (result.data) {
          setTokenStorage(result.data);
        }

        window.sessionStorage.setItem('passport_sign_psw', obj.password);
        window.sessionStorage.setItem('passport_sign_account', (obj.email || obj.mobile || '') as string);
        callback && callback();

      }
    }).catch((error: any) => {
      console.log(error);
    });
  };


  @action
  validateMobile = (mobile: string, areaCode: string) => {
    const params = {
      mobileAccount: mobile,
      areaCode: areaCode
    }
    SignAPI.validateMobile(params).then((result: any) => {
      runInAction(() => {
        if (result?.data?.errorMsg) {
          toast({
            content: getLabel(result.data.errorMsg?.i18nId, result.data.errorMsg.msg)
          })
        }
      });
    }).catch((error: any) => {
      console.log(error);
    });
  }

  @action
  validateEmail = (email?: string) => {
    SignAPI.validateEmail(email).then((result: any) => {
      runInAction(() => {
        if (result?.data?.errorMsg) {
          toast({
            content: result.data.errorMsg.i18nId ?
              getLabel(result.data.errorMsg.i18nId, result.data.errorMsg.msg) :
              result.data.errorMsg.msg
          })
        }
      });
    }).catch((error: any) => {
      console.log(error);
    });
  }
  @action
  validateAccount = (obj: any) => {
    // 验证手机号
    if (obj.isPhone) {
      this.validateMobile(obj.account, obj.areaCode)
    }
    // 验证邮箱
    else {
      this.validateEmail(obj.account)
    }
  };
}

const instance = new mLoginStore();

export default instance;
